import Rides from "./rides";

export default  Rides;
